import { render, staticRenderFns } from "./NewOrderView.vue?vue&type=template&id=60c202d5&"
import script from "./NewOrderView.vue?vue&type=script&lang=js&"
export * from "./NewOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports